<template>
  <div class="dynamic-row">
    <div class="travel-service">
      <div class="content">
        <div v-if="cbHtml" v-html="cbHtml"></div>
        <el-empty v-else description="暂无数据" style="height:555px;"></el-empty>
        <!-- <img src="@/assets/img/details/1.jpg" alt="">
        <img src="@/assets/img/details/2.jpg" alt="">
        <img src="@/assets/img/details/3.jpg" alt="">
        <img src="@/assets/img/details/4.jpg" alt=""> -->
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  data(){
    return {
      cbHtml:''
    }
  },
  created(){
    this.cbHtml = localStorage.getItem("content")
  },
  destroyed(){
    localStorage.clear()
  }
}
</script>


<style lang="scss">
@import './news-tidal-details.scss';
</style>



// WEBPACK FOOTER //
// src/views/news-tidal/news-tidal-details/news-tidal-details.vue